import {
  CSSDimension,
  getColorByPath,
  getCssSize,
  Integer,
  ThemeColorPath,
  ThemeRadiusPath,
} from 'platform/foundation';
import styled from 'styled-components';

import {ReactNode} from 'react';

import {isNotNil} from 'ramda';

import {getSafely} from 'shared/web';

interface HoverableBoxProps {
  children: ReactNode;
  width?: CSSDimension | Integer;
  height?: CSSDimension | Integer;
  padding?: Integer;
  borderRadius?: ThemeRadiusPath;
  backgroundColor?: ThemeColorPath;
  borderColor?: ThemeColorPath;
  hoverBackgroundColor?: ThemeColorPath;
  hoverBorderColor?: ThemeColorPath;
}

export function HoverableBox(props: HoverableBoxProps) {
  return (
    <StyledHoverableBox
      $width={props.width}
      $height={props.height}
      $padding={props.padding}
      $borderRadius={props.borderRadius}
      $backgroundColor={props.backgroundColor}
      $borderColor={props.borderColor}
      $hoverBackgroundColor={props.hoverBackgroundColor}
      $hoverBorderColor={props.hoverBorderColor}
    >
      {props.children}
    </StyledHoverableBox>
  );
}

interface StyledHoverableBoxProps {
  $width?: CSSDimension | Integer;
  $height?: CSSDimension | Integer;
  $padding?: Integer;
  $borderRadius?: ThemeRadiusPath;
  $backgroundColor?: ThemeColorPath;
  $borderColor?: ThemeColorPath;
  $hoverBackgroundColor?: ThemeColorPath;
  $hoverBorderColor?: ThemeColorPath;
}

// Uses styled.div instead of a platform/foundation primitive because no platform
// primitive exposes CSS :hover pseudo-selectors, which are required for the hover transition.
const StyledHoverableBox = styled.div<StyledHoverableBoxProps>`
  width: ${({$width}) => getCssSize($width)};
  height: ${({$height}) => getCssSize($height)};
  padding: ${({$padding}) => getCssSize($padding)};
  border-radius: ${({theme, $borderRadius}) =>
    isNotNil($borderRadius) ? getSafely(theme.radii, $borderRadius) : undefined};
  border: ${({theme, $borderColor}) =>
    isNotNil($borderColor) ? `1px solid ${getColorByPath($borderColor, theme)}` : undefined};
  background-color: ${({theme, $backgroundColor}) => getColorByPath($backgroundColor, theme)};
  transition:
    background-color 0.2s ease-in-out,
    border-color 0.2s ease-in-out;

  &:hover {
    background-color: ${({theme, $hoverBackgroundColor}) =>
      getColorByPath($hoverBackgroundColor, theme)};
    border-color: ${({theme, $hoverBorderColor}) => getColorByPath($hoverBorderColor, theme)};
  }
`;
